export default "__VITE_ASSET__BacUuHIJ__"